"use client";
import Image from "next/image";
import { getOrdinalFor } from "@packages/shared-components/services/utils";
import Getprospectus from "../cards/interaction-button/getprospectus";
import UserFavourite from "../user-favourite/UserFavourite";
import { generateProviderResultUrl } from "@packages/lib/utlils/url-builder";
import { isPGS, isWhatuni } from "@packages/lib/utlils/commonFunction";
import ApplyNow from "@packages/shared-components/common-utilities/cards/interaction-button/applynow";

const SimilarUniCard = ({ uniInfo, isPostgraduate }: any) => {
  const commonGAAttrs: any = {};
  const hasCtas =
    (uniInfo?.prospectusFlag === "Y" && isWhatuni()) ||
    (isPGS() && uniInfo?.applyNowFlag === "Y");

  const getEnquiryDetailsForTracking = () => {
    return {
      ...uniInfo,
      subOrderItemId: uniInfo?.subOrderItemId,
      orderItemId: uniInfo?.orderItemId,
      collegeId: uniInfo?.collegeId,
      qualCode: uniInfo?.qualCode || "",
      collegeName: uniInfo?.institutionProfileUrl,

      csPageName:
        typeof window !== "undefined" && localStorage.getItem("gaPageName")
          ? localStorage.getItem("gaPageName")
          : "institutionpage",
      pageName: "contenthub",
      collegeDisplayName: uniInfo?.collegeDispName,
      sectionName: "why-study-here",
    };
  };
  //   function LogClick() {
  //     clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "", clearing);
  //     gaForCtaClicks(
  //       getEnquiryDetailsForTracking(),
  //       "VISIT WEBSITE",
  //       uniInfo?.websiteUrl || "NA",
  //       "clearing_webclick",
  //       commonGAAttrs
  //     );
  //   }

  return (
    <div
      className={`card flex flex-col justify-between h-full bg-white border border-grey-200 rounded-[8px] shadow-custom-2 overflow-hidden`}
    >
      <div className="card-header relative z-0 min-h-min bg-grey-200">
        {uniInfo?.imagePath ? (
          <Image
            src={process.env.NEXT_PUBLIC_IMAGE_DOMAIN + uniInfo?.imagePath}
            width="392"
            height="221"
            className={`block w-full h-auto "min-h-[147px]"}`}
            alt={"Elite-card-banner-" + uniInfo?.collegeDispName}
            onError={(e) => console.log(e)}
          />
        ) : (
          <span className={`flex w-full h-[243px] md:h-[254px] lg:h-[221px] xl:h-[205px] ${process.env.PROJECT === "Whatuni" ? "bg-blue-200" : "bg-green-200"}`}></span>
        )}
        {uniInfo?.collegeLogo && (
          <div className="absolute z-[1] top-[16px] left-[16px] rounded-[8px] overflow-hidden">
            <Image
              src={process.env.NEXT_PUBLIC_IMAGE_DOMAIN + uniInfo?.collegeLogo}
              width="64"
              height="64"
              alt={"Elite-card-logo-" + uniInfo?.collegeDispName}
              loading="lazy"
            />
          </div>
        )}
        <div className="absolute top-[16px] right-[16px] z-[1]">
          <UserFavourite
            similaruni={true}
            contentId={uniInfo?.idpProviderId}
            contentName={uniInfo?.idpcInstitutionName}
            contentType="INSTITUTION"
            statsGAData={{}}
          />
        </div>
      </div>

      <div
        className={`card-body flex flex-col ${hasCtas ? "justify-between min-h-[192px]" : ""} gap-[20px] p-[16px] h-full`}
      >
        <div className="flex flex-col gap-[8px] w-full">
          <div
            className={`clearing-tag xs-small font-bold bg-grey-100 text-grey500 uppercase w-fit rounded-[4px] p-[0_8px]`}
          >
            {uniInfo?.podLabel}
          </div>
          <div className="card-title font-farro para-lg font-bold text-grey300 line-clamp-2">
            {uniInfo?.collegeDispName}
          </div>
          <div className="para small font-semibold line-clamp-1">
            WUSCA overall ranking
          </div>
          <div className="rating-pod flex items-center gap-[8px]">
            {uniInfo?.overallRatingExact && (
              <div className="rating-card flex items-center gap-[4px]">
                <Image
                  src="/static/assets/icons/blue-star-icon.svg"
                  width="24"
                  height="24"
                  alt="Rating icon"
                />
                <span className="font-normal small text-grey300">
                  {uniInfo?.overallRatingExact} / 5
                </span>
              </div>
            )}
            {uniInfo?.wuscaRanking && (
              <span className="block font-normal small text-grey-700">
                {uniInfo?.wuscaRanking + getOrdinalFor(+uniInfo?.wuscaRanking)}
              </span>
            )}
          </div>
        </div>
        {hasCtas && (
          <div className={`flex gap-[8px] w-full flex-col`}>
            {uniInfo?.prospectusFlag === "Y" && isWhatuni() && (
              <Getprospectus
                enquiryProps={{
                  ...getEnquiryDetailsForTracking(),
                }}
                commonGAAttrs={commonGAAttrs}
                // btnColor={"btn-blue"}
                // clearing={
                //     process.env.NEXT_PUBLIC_CLEARING_FLAG?.toLowerCase() === "on"
                // }
              />
            )}
            {isPGS() && uniInfo?.applyNowFlag === "Y" && (
              <ApplyNow
                enquiryProps={{
                  ...getEnquiryDetailsForTracking(),
                  eventType: "",
                  functionalityName: "",
                }}
                commonGAAttrs={commonGAAttrs}
              />
            )}
          </div>
        )}
      </div>

      <div className="bottom-section border-t border-grey-200 p-[12px] text-center">
        <a
          href={generateProviderResultUrl({
            institutionTextkey: uniInfo?.institutionProfileUrl,
            isPostgraduate,
          })}
          className="text-blue-600 font-semibold text-[14px] hover:underline"
        >
          View {uniInfo?.courseCount} courses
        </a>
      </div>
    </div>
  );
};

export default SimilarUniCard;
